import HttpClient from "@/common/HttpClient";
import {StartMassProductReturnInspectionResponse} from "@/models/server/StartMassProductReturnInspectionResponse";
import EndpointPaths from "@/common/EndpointPaths";
import RentaToolsController from "@/pages/RentaToolsController";
import ReturnInspectionController from "@/pages/ReturnInspectionController";
import {CompleteMassReturnInspectionResponse} from "@/models/server/responses/CompleteMassReturnInspectionResponse";
import {PageRouteProvider} from "@renta-apps/athenaeum-react-common";
import PageDefinitions from "@/providers/PageDefinitions";
import {ViewMassReturnInspectionResponse} from "@/models/server/responses/ViewMassReturnInspectionResponse";
import {
    ContinueMassProductReturnInspectionResponse
} from "@/models/server/responses/ContinueMassProductReturnInspectionResponse";
import {StopMassReturnInspectionResponse} from "@/models/server/responses/StopMassReturnInspectionResponse";
import {
    CompleteMassProductReturnInspectionRequest,
    StartMassProductReturnInspectionRequest,
    StopMassProductInspectionRequest,
    ContinueMassProductReturnInspectionRequest,
    ViewMassProductReturnInspectionRequest, 
    PartlyCompleteMassProductReturnInspectionRequest
} from "@/models/server/requests/massProducts";
import GetMassProductOngoingReportResponse from "@/models/server/responses/GetMassProductOngoingReportResponse";
import {
    PartlyCompleteMassProductReturnInspectionResponse
} from "@/models/server/responses/PartlyCompleteMassProductReturnInspectionResponse";

class ReturnedMassProductController {
    public async StartReturnInspection(id : string){
        const request : StartMassProductReturnInspectionRequest = {
            requestReturnedMassProductId : id,
        }
        
        const response = await HttpClient.postAsyncWithoutErrorHandling<StartMassProductReturnInspectionResponse>(EndpointPaths.MassProductReturnInspection.StartMassProductReturnInspection, request);
        
        if(response.success) {
            RentaToolsController.context.report = response.report;
            RentaToolsController.context.preview = false;

            RentaToolsController.saveContext();
            
            await ReturnInspectionController.openStepAsync(0);
        }
    }

    public async SaveMassProductReturnInspection() {
        const report = RentaToolsController.context.report;
        
        if(report && report.returnedContractId) {
            const request: CompleteMassProductReturnInspectionRequest = {
                requestReturnedMassProductId: report.returnedContractId,
                items: report.items
            }

            const response = await HttpClient.postAsyncWithoutErrorHandling<CompleteMassReturnInspectionResponse>(EndpointPaths.MassProductReturnInspection.CompleteReturnInspection, request);

            if (response.success) {
                RentaToolsController.context.report = null;
                RentaToolsController.context.preview = false;


                await PageRouteProvider.redirectAsync(PageDefinitions.dashboardRoute);
            }
        }
    }

    public async ContinueReturnInspection(id: string) {
        const request : ContinueMassProductReturnInspectionRequest = {
            requestReturnedMassProductId: id,
        }
        
        const response = await HttpClient.postAsyncWithoutErrorHandling<ContinueMassProductReturnInspectionResponse>(EndpointPaths.MassProductReturnInspection.ContinueMassProductReturnInspection, request);

        if(response.success) {
            RentaToolsController.context.report = response.report;
            RentaToolsController.context.preview = false;

            RentaToolsController.saveContext();

            const route = PageDefinitions.summaryRoute;

            await PageRouteProvider.redirectAsync(route);
        }
    
    }

    public async ViewReturnInspection(id: string) {
        const request : ViewMassProductReturnInspectionRequest = {
            requestReturnedMassProductId: id,
        };
        
        const response = await HttpClient.postAsyncWithoutErrorHandling<ViewMassReturnInspectionResponse>(EndpointPaths.MassProductReturnInspection.ViewMassProductInspection, request);
        
        if(response.success) {
            RentaToolsController.reportPreview = response.report;
            
            const route = PageDefinitions.reportPreviewRoute;

            await PageRouteProvider.redirectAsync(route);
        }
    }

    async StopMassProductInspection(massProductReportId: string) : Promise<boolean> {
        const request : StopMassProductInspectionRequest = {
            requestReturnedMassProductId: massProductReportId,
        };

        const response = await HttpClient.postAsyncWithoutErrorHandling<StopMassReturnInspectionResponse>(EndpointPaths.MassProductReturnInspection.StopMassProductInspection, request);

        return response.success;
    }

    async GetMassProductOngoingReport() : Promise<GetMassProductOngoingReportResponse> {
        return HttpClient.postAsync<GetMassProductOngoingReportResponse>(EndpointPaths.MassProductReturnInspection.GetOnGoingMassProductInspection);
    }

    async PartlyCompleteReturnInspection(massProductReportId: string | null) {
        if(massProductReportId){
            const request : PartlyCompleteMassProductReturnInspectionRequest = {
                requestReturnedMassProductId: massProductReportId
            };

            const response = await HttpClient.postAsyncWithoutErrorHandling<PartlyCompleteMassProductReturnInspectionResponse>(EndpointPaths.MassProductReturnInspection.PartlyCompleteMassProductInspection, request);

            if(response.success) {
                RentaToolsController.context.report = null;
                RentaToolsController.context.preview = false;

                RentaToolsController.saveContext();
                
                const route = PageDefinitions.dashboardRoute;
                await PageRouteProvider.redirectAsync(route);
            }
        }
    }
}

export default new ReturnedMassProductController();